"use client";
import React, { useState, useEffect, useRef } from "react";
import "./global.css";
import HeroSection from "./components/HeroSection/HeroSection";

export default function Home() {
  return (
    <HeroSection />
  );
}
